export var AnnouncementStatus;
(function (AnnouncementStatus) {
    AnnouncementStatus["ARCHIVED"] = "ARCHIVED";
    AnnouncementStatus["DRAFT"] = "DRAFT";
    AnnouncementStatus["PUBLISHED"] = "PUBLISHED";
})(AnnouncementStatus || (AnnouncementStatus = {}));
export var AuditTrailRecordType;
(function (AuditTrailRecordType) {
    AuditTrailRecordType["CALIBRATION"] = "CALIBRATION";
    AuditTrailRecordType["CALIBRATION_SHEPHERD"] = "CALIBRATION_SHEPHERD";
    AuditTrailRecordType["CANDIDATE"] = "CANDIDATE";
    AuditTrailRecordType["INTERVIEWER"] = "INTERVIEWER";
    AuditTrailRecordType["LOOP_EVENT"] = "LOOP_EVENT";
    AuditTrailRecordType["PHONE_SCREEN"] = "PHONE_SCREEN";
    AuditTrailRecordType["ROUTING_ATTEMPT"] = "ROUTING_ATTEMPT";
})(AuditTrailRecordType || (AuditTrailRecordType = {}));
export var AvailabilityState;
(function (AvailabilityState) {
    AvailabilityState["AVAILABLE"] = "AVAILABLE";
    AvailabilityState["BLOCKED"] = "BLOCKED";
    AvailabilityState["CLAIMED"] = "CLAIMED";
    AvailabilityState["DECLINED"] = "DECLINED";
    AvailabilityState["REQUESTED"] = "REQUESTED";
})(AvailabilityState || (AvailabilityState = {}));
export var BarRaiserStatus;
(function (BarRaiserStatus) {
    BarRaiserStatus["BR"] = "BR";
    BarRaiserStatus["BRIT"] = "BRIT";
    BarRaiserStatus["NONE"] = "NONE";
})(BarRaiserStatus || (BarRaiserStatus = {}));
export var CalibrationStatus;
(function (CalibrationStatus) {
    CalibrationStatus["CALIBRATED"] = "CALIBRATED";
    CalibrationStatus["INDEPENDENT"] = "INDEPENDENT";
    CalibrationStatus["IN_CALIBRATION"] = "IN_CALIBRATION";
    CalibrationStatus["NOT_CALIBRATED"] = "NOT_CALIBRATED";
})(CalibrationStatus || (CalibrationStatus = {}));
export var CategoryStatus;
(function (CategoryStatus) {
    CategoryStatus["ACTIVE"] = "ACTIVE";
    CategoryStatus["DELETED"] = "DELETED";
})(CategoryStatus || (CategoryStatus = {}));
export var CommentType;
(function (CommentType) {
    CommentType["CANCELLATION"] = "CANCELLATION";
    CommentType["EVENT"] = "EVENT";
    CommentType["FEEDBACK"] = "FEEDBACK";
    CommentType["PROFILE"] = "PROFILE";
})(CommentType || (CommentType = {}));
export var ElevateApps;
(function (ElevateApps) {
    ElevateApps["INTERVIEW_MANAGEMENT"] = "INTERVIEW_MANAGEMENT";
    ElevateApps["NONE"] = "NONE";
    ElevateApps["PROMOHUB"] = "PROMOHUB";
    ElevateApps["QUESTION_BANK"] = "QUESTION_BANK";
})(ElevateApps || (ElevateApps = {}));
export var EventParticipantMode;
(function (EventParticipantMode) {
    EventParticipantMode["ALL"] = "ALL";
    EventParticipantMode["LEAD"] = "LEAD";
    EventParticipantMode["NONE"] = "NONE";
    EventParticipantMode["SHADOW"] = "SHADOW";
})(EventParticipantMode || (EventParticipantMode = {}));
export var EventStatus;
(function (EventStatus) {
    EventStatus["CANCELLED"] = "CANCELLED";
    EventStatus["COMPLETED"] = "COMPLETED";
    EventStatus["SCHEDULED"] = "SCHEDULED";
})(EventStatus || (EventStatus = {}));
export var EventType;
(function (EventType) {
    EventType["LOOP"] = "LOOP";
    EventType["PHONE_SCREEN"] = "PHONE_SCREEN";
})(EventType || (EventType = {}));
export var FileRecordStatus;
(function (FileRecordStatus) {
    FileRecordStatus["ACTIVE"] = "ACTIVE";
    FileRecordStatus["DELETED"] = "DELETED";
    FileRecordStatus["HIDDEN"] = "HIDDEN";
})(FileRecordStatus || (FileRecordStatus = {}));
export var HireDecision;
(function (HireDecision) {
    HireDecision["INCLINED"] = "INCLINED";
    HireDecision["NOT_INCLINED"] = "NOT_INCLINED";
    HireDecision["NOT_SET"] = "NOT_SET";
})(HireDecision || (HireDecision = {}));
export var InterviewType;
(function (InterviewType) {
    InterviewType["ELEVATE"] = "ELEVATE";
    InterviewType["EXTERNAL"] = "EXTERNAL";
})(InterviewType || (InterviewType = {}));
export var InterviewerRole;
(function (InterviewerRole) {
    InterviewerRole["INDEPENDENT"] = "INDEPENDENT";
    InterviewerRole["LEAD"] = "LEAD";
    InterviewerRole["REVERSE_SHADOW"] = "REVERSE_SHADOW";
    InterviewerRole["SHADOW"] = "SHADOW";
})(InterviewerRole || (InterviewerRole = {}));
export var JobLevel;
(function (JobLevel) {
    JobLevel["L4"] = "L4";
    JobLevel["L5"] = "L5";
    JobLevel["L6"] = "L6";
    JobLevel["L7"] = "L7";
    JobLevel["L8"] = "L8";
    JobLevel["L9"] = "L9";
    JobLevel["L10"] = "L10";
})(JobLevel || (JobLevel = {}));
export var LanguageProficiency;
(function (LanguageProficiency) {
    LanguageProficiency["BASIC"] = "BASIC";
    LanguageProficiency["CONVERSATIONAL"] = "CONVERSATIONAL";
    LanguageProficiency["FLUENT_OR_NATIVE"] = "FLUENT_OR_NATIVE";
    LanguageProficiency["NONE"] = "NONE";
})(LanguageProficiency || (LanguageProficiency = {}));
export var LanguageRecordType;
(function (LanguageRecordType) {
    LanguageRecordType["PROFICIENCY"] = "PROFICIENCY";
    LanguageRecordType["REQUIREMENT"] = "REQUIREMENT";
})(LanguageRecordType || (LanguageRecordType = {}));
export var LoopConfigBrMode;
(function (LoopConfigBrMode) {
    LoopConfigBrMode["DEBRIEF_ONLY"] = "DEBRIEF_ONLY";
    LoopConfigBrMode["FULL"] = "FULL";
    LoopConfigBrMode["NOT_REQUIRED"] = "NOT_REQUIRED";
})(LoopConfigBrMode || (LoopConfigBrMode = {}));
export var ManagedTranscriptStatus;
(function (ManagedTranscriptStatus) {
    ManagedTranscriptStatus["COMPLETED"] = "COMPLETED";
    ManagedTranscriptStatus["FAILED"] = "FAILED";
    ManagedTranscriptStatus["UNKNOWN"] = "UNKNOWN";
})(ManagedTranscriptStatus || (ManagedTranscriptStatus = {}));
export var ModelAttributeTypes;
(function (ModelAttributeTypes) {
    ModelAttributeTypes["_null"] = "_null";
    ModelAttributeTypes["binary"] = "binary";
    ModelAttributeTypes["binarySet"] = "binarySet";
    ModelAttributeTypes["bool"] = "bool";
    ModelAttributeTypes["list"] = "list";
    ModelAttributeTypes["map"] = "map";
    ModelAttributeTypes["number"] = "number";
    ModelAttributeTypes["numberSet"] = "numberSet";
    ModelAttributeTypes["string"] = "string";
    ModelAttributeTypes["stringSet"] = "stringSet";
})(ModelAttributeTypes || (ModelAttributeTypes = {}));
export var ModelSortDirection;
(function (ModelSortDirection) {
    ModelSortDirection["ASC"] = "ASC";
    ModelSortDirection["DESC"] = "DESC";
})(ModelSortDirection || (ModelSortDirection = {}));
export var OrgCalibrationShepherdMode;
(function (OrgCalibrationShepherdMode) {
    OrgCalibrationShepherdMode["ASSIGN_DEFAULT_CALIBRATION_SHEPHERD"] = "ASSIGN_DEFAULT_CALIBRATION_SHEPHERD";
    OrgCalibrationShepherdMode["ASSIGN_DIRECT_LINE_MANAGER"] = "ASSIGN_DIRECT_LINE_MANAGER";
    OrgCalibrationShepherdMode["NO_ACTION"] = "NO_ACTION";
})(OrgCalibrationShepherdMode || (OrgCalibrationShepherdMode = {}));
export var OrgConfigDefinitionType;
(function (OrgConfigDefinitionType) {
    OrgConfigDefinitionType["LOOP_CALIBRATION"] = "LOOP_CALIBRATION";
    OrgConfigDefinitionType["LOOP_CONFIG"] = "LOOP_CONFIG";
    OrgConfigDefinitionType["LOOP_PARTICIPANT"] = "LOOP_PARTICIPANT";
    OrgConfigDefinitionType["PHONESCREEN_CALIBRATION"] = "PHONESCREEN_CALIBRATION";
    OrgConfigDefinitionType["PHONESCREEN_CONFIG"] = "PHONESCREEN_CONFIG";
    OrgConfigDefinitionType["PHONESCREEN_PARTICIPANT"] = "PHONESCREEN_PARTICIPANT";
    OrgConfigDefinitionType["PROMO_PANEL_CALIBRATION"] = "PROMO_PANEL_CALIBRATION";
})(OrgConfigDefinitionType || (OrgConfigDefinitionType = {}));
export var OrganizationStatus;
(function (OrganizationStatus) {
    OrganizationStatus["ACTIVE"] = "ACTIVE";
    OrganizationStatus["ARCHIVED"] = "ARCHIVED";
    OrganizationStatus["INACTIVE"] = "INACTIVE";
})(OrganizationStatus || (OrganizationStatus = {}));
export var PathDefinitionType;
(function (PathDefinitionType) {
    PathDefinitionType["CANDIDATE"] = "CANDIDATE";
    PathDefinitionType["MANAGER"] = "MANAGER";
    PathDefinitionType["ORGANIZATION"] = "ORGANIZATION";
    PathDefinitionType["SYSTEM"] = "SYSTEM";
})(PathDefinitionType || (PathDefinitionType = {}));
export var PeerReviewStatus;
(function (PeerReviewStatus) {
    PeerReviewStatus["COMPLETED"] = "COMPLETED";
    PeerReviewStatus["DELETED"] = "DELETED";
    PeerReviewStatus["PENDING"] = "PENDING";
    PeerReviewStatus["REQUESTED"] = "REQUESTED";
    PeerReviewStatus["RETURNED_FOR_REVISION"] = "RETURNED_FOR_REVISION";
})(PeerReviewStatus || (PeerReviewStatus = {}));
export var PeerReviewType;
(function (PeerReviewType) {
    PeerReviewType["CANDIDATE"] = "CANDIDATE";
    PeerReviewType["MANAGER"] = "MANAGER";
})(PeerReviewType || (PeerReviewType = {}));
export var ProfileStatus;
(function (ProfileStatus) {
    ProfileStatus["ACTIVE"] = "ACTIVE";
    ProfileStatus["INACTIVE"] = "INACTIVE";
})(ProfileStatus || (ProfileStatus = {}));
export var PromoPathStatus;
(function (PromoPathStatus) {
    PromoPathStatus["ACTIVE"] = "ACTIVE";
    PromoPathStatus["ASSIGNED"] = "ASSIGNED";
    PromoPathStatus["COMPLETED"] = "COMPLETED";
    PromoPathStatus["DELETED"] = "DELETED";
})(PromoPathStatus || (PromoPathStatus = {}));
export var QuestionShareability;
(function (QuestionShareability) {
    QuestionShareability["PRIVATE"] = "PRIVATE";
    QuestionShareability["PUBLIC"] = "PUBLIC";
})(QuestionShareability || (QuestionShareability = {}));
export var QuestionStatus;
(function (QuestionStatus) {
    QuestionStatus["ACTIVE"] = "ACTIVE";
    QuestionStatus["INACTIVE"] = "INACTIVE";
})(QuestionStatus || (QuestionStatus = {}));
export var RecursionInterval;
(function (RecursionInterval) {
    RecursionInterval["DAILY"] = "DAILY";
    RecursionInterval["MONTHLY"] = "MONTHLY";
    RecursionInterval["WEEKLY"] = "WEEKLY";
})(RecursionInterval || (RecursionInterval = {}));
export var Roles;
(function (Roles) {
    Roles["CALIBRATION_SHEPHERD"] = "CALIBRATION_SHEPHERD";
    Roles["ELEVATE_ADMIN"] = "ELEVATE_ADMIN";
    Roles["EVENT_LEAD"] = "EVENT_LEAD";
    Roles["INTERVIEWER"] = "INTERVIEWER";
    Roles["ORG_ADMIN"] = "ORG_ADMIN";
    Roles["PREFERRED_BR"] = "PREFERRED_BR";
    Roles["PROMO_DOC_REVIEWER"] = "PROMO_DOC_REVIEWER";
    Roles["PROMO_PANEL_MEMBER"] = "PROMO_PANEL_MEMBER";
    Roles["RECRUITER"] = "RECRUITER";
})(Roles || (Roles = {}));
export var RoutingState;
(function (RoutingState) {
    /** User Said they will take the interview */
    RoutingState["ACCEPTED"] = "ACCEPTED";
    /** Manual Intervention was taken to skip this user before they could respond */
    RoutingState["CONTINUED"] = "CONTINUED";
    /** User said they won't take the interview */
    RoutingState["DECLINED"] = "DECLINED";
    /** User did not provide a response in time */
    RoutingState["NO_RESPONSE"] = "NO_RESPONSE";
    /** Waiting For user Feedback */
    RoutingState["PENDING"] = "PENDING";
})(RoutingState || (RoutingState = {}));
export var TrainingPlatformType;
(function (TrainingPlatformType) {
    TrainingPlatformType["KNET"] = "KNET";
    TrainingPlatformType["KNET2"] = "KNET2";
    TrainingPlatformType["LEARN"] = "LEARN";
})(TrainingPlatformType || (TrainingPlatformType = {}));
export var TrainingStatus;
(function (TrainingStatus) {
    TrainingStatus["ARCHIVED"] = "ARCHIVED";
    TrainingStatus["COMPLETED"] = "COMPLETED";
    TrainingStatus["DRAFT"] = "DRAFT";
    TrainingStatus["INACTIVE"] = "INACTIVE";
    TrainingStatus["LIVE"] = "LIVE";
    TrainingStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    TrainingStatus["PENDING_CONTENT_PROCESSING"] = "PENDING_CONTENT_PROCESSING";
})(TrainingStatus || (TrainingStatus = {}));
export var TrainingType;
(function (TrainingType) {
    TrainingType["AUDIO"] = "AUDIO";
    TrainingType["COHORT"] = "COHORT";
    TrainingType["COURSE"] = "COURSE";
    TrainingType["DISCUSSION"] = "DISCUSSION";
    TrainingType["DOCUMENT"] = "DOCUMENT";
    TrainingType["EVENT"] = "EVENT";
    TrainingType["EXTERNAL_CONTENT"] = "EXTERNAL_CONTENT";
    TrainingType["EXTERNAL_TRAINING"] = "EXTERNAL_TRAINING";
    TrainingType["FORM"] = "FORM";
    TrainingType["ILT"] = "ILT";
    TrainingType["LEARNING_PATH"] = "LEARNING_PATH";
    TrainingType["MATERIAL"] = "MATERIAL";
    TrainingType["NOTE"] = "NOTE";
    TrainingType["OBSERVATION_CHECKLIST"] = "OBSERVATION_CHECKLIST";
    TrainingType["ONLINE_CLASS"] = "ONLINE_CLASS";
    TrainingType["ONLINE_CONTENT"] = "ONLINE_CONTENT";
    TrainingType["ONLINE_RESOURCE"] = "ONLINE_RESOURCE";
    TrainingType["PART"] = "PART";
    TrainingType["PROGRAM"] = "PROGRAM";
    TrainingType["QANDA"] = "QANDA";
    TrainingType["QUICK_COURSE"] = "QUICK_COURSE";
    TrainingType["SESSION"] = "SESSION";
    TrainingType["TEST"] = "TEST";
    TrainingType["VIDEO"] = "VIDEO";
    TrainingType["WEBLINK"] = "WEBLINK";
})(TrainingType || (TrainingType = {}));
export var TranscriptStatus;
(function (TranscriptStatus) {
    TranscriptStatus["CANCELLED"] = "CANCELLED";
    TranscriptStatus["COMPLETED"] = "COMPLETED";
    TranscriptStatus["FAILED"] = "FAILED";
    TranscriptStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TranscriptStatus["PENDING_POST_REQUISITE"] = "PENDING_POST_REQUISITE";
    TranscriptStatus["PENDING_POST_WORK"] = "PENDING_POST_WORK";
    TranscriptStatus["PENDING_PRE_REQUISITE"] = "PENDING_PRE_REQUISITE";
    TranscriptStatus["PENDING_PRE_WORK"] = "PENDING_PRE_WORK";
    TranscriptStatus["REGISTERED"] = "REGISTERED";
    TranscriptStatus["REQUESTED"] = "REQUESTED";
    TranscriptStatus["UNKNOWN"] = "UNKNOWN";
})(TranscriptStatus || (TranscriptStatus = {}));
export var WorkSummaryStatus;
(function (WorkSummaryStatus) {
    WorkSummaryStatus["APPROVED"] = "APPROVED";
    WorkSummaryStatus["DELETED"] = "DELETED";
    WorkSummaryStatus["DRAFT"] = "DRAFT";
    WorkSummaryStatus["MANAGER_PEER_REVIEW"] = "MANAGER_PEER_REVIEW";
    WorkSummaryStatus["MANAGER_REVIEW"] = "MANAGER_REVIEW";
    WorkSummaryStatus["PEER_REVIEW"] = "PEER_REVIEW";
    WorkSummaryStatus["REJECTED"] = "REJECTED";
})(WorkSummaryStatus || (WorkSummaryStatus = {}));
export var WorkSummaryStatusReason;
(function (WorkSummaryStatusReason) {
    WorkSummaryStatusReason["ADMIN_STATUS_CHANGE"] = "ADMIN_STATUS_CHANGE";
    WorkSummaryStatusReason["CONTENT_NOT_USABLE"] = "CONTENT_NOT_USABLE";
    WorkSummaryStatusReason["MANAGER_FINAL_APPROVAL"] = "MANAGER_FINAL_APPROVAL";
    WorkSummaryStatusReason["MANAGER_INITIAL_APPROVAL"] = "MANAGER_INITIAL_APPROVAL";
    WorkSummaryStatusReason["PEER_REVIEW_COMPLETE"] = "PEER_REVIEW_COMPLETE";
    WorkSummaryStatusReason["PROMO_PATH_ASSIGNMENT_CHANGE"] = "PROMO_PATH_ASSIGNMENT_CHANGE";
    WorkSummaryStatusReason["RETURNED_FOR_UPDATES"] = "RETURNED_FOR_UPDATES";
})(WorkSummaryStatusReason || (WorkSummaryStatusReason = {}));
export var WorkSummaryType;
(function (WorkSummaryType) {
    WorkSummaryType["AMAZON"] = "AMAZON";
    WorkSummaryType["CUSTOMER"] = "CUSTOMER";
})(WorkSummaryType || (WorkSummaryType = {}));
//# sourceMappingURL=data:application/json;base64,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